import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContactUpdateState, ContactUpdateFeatureName } from './contact-update.reducer';

export const ContactUpdateFeatureSelector =
    createFeatureSelector<ContactUpdateState>(ContactUpdateFeatureName);

export const ContactUpdateIsInitiatingSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.isInitiating
);

export const ContactUpdateIsVerifyingSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.isVerifying
);

export const ContactUpdateIsSubmittingSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.isInitiating || state.isVerifying
);

export const ContactUpdateVerificationIdSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.verificationId
);

export const ContactUpdateDestinationMaskedSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.destinationMasked
);

export const ContactUpdateMobileSuccessSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.mobileUpdateSuccess
);

export const ContactUpdateErrorSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.error
);

export const ContactUpdateErrorTypeSelector = createSelector(
    ContactUpdateFeatureSelector,
    (state) => state.errorType
);
